import React from "react";


const LoaddingComponent=()=>{
    return (
    <div className="center height100">
        <img alt="Logo"  className="height100 width85" src='assets/layout/images/loadding.svg' />
    </div>
)}
export default LoaddingComponent